import { useCallback } from 'react';
import { useInstantSearch } from 'react-instantsearch';

import { FORUM_SEARCH_REFRESH_DELAYS } from '../../../config/constants';

/**
 * Hook for triggering a search refresh on the current search context.
 * Can only be used within an instantsearch context.
 *
 * @param delays - Array of setTimeout intervals for polling the search.
 *
 * @returns
 *   triggerSearchRefresh: function to trigger the refresh.
 */
const useRefreshTrigger = (delays: number[] = FORUM_SEARCH_REFRESH_DELAYS) => {
  const { refresh } = useInstantSearch();

  const triggerSearchRefresh = useCallback(() => {
    delays.forEach((delay) => {
      setTimeout(() => {
        refresh();
      }, delay);
    });
  }, [delays, refresh]);

  return {
    triggerSearchRefresh,
  };
};

export default useRefreshTrigger;
